import { ApiClient } from '@/apiClient'
import type { GetSettingsResponse } from '@/interfaces/GetSettingsResponse'
import type { Setting } from '@/interfaces/Setting'
import * as Sentry from "@sentry/browser";
import type { AxiosResponse } from 'axios';

export class SettingsService {
  apiClient: ApiClient = new ApiClient()

  async getSettings(): Promise<GetSettingsResponse> {
    const getSettingResponse: GetSettingsResponse = {
      success: false
    }

    await this.apiClient
      .getSettings()
      .then((response: AxiosResponse<any>) => {
        if (response != undefined) {
          if (response.status === 200) {
            getSettingResponse.success = true
            getSettingResponse.settings = response.data

            return response
          }
          getSettingResponse.error = response.data.errors
        }
        return response
      })
      .catch((_: any) => {
        Sentry.captureException(_);
        getSettingResponse.error = 'Server error'
      })

    return getSettingResponse
  }

  async update(settings:Setting): Promise<GetSettingsResponse> {
    const getSettingResponse: GetSettingsResponse = {
      success: false
    }

    await this.apiClient
      .updateSettings(settings)
      .then((response: any) => {
        if (response != undefined) {
          if (response.status === 200) {
            getSettingResponse.success = true
            getSettingResponse.settings = response.data

            return response
          }
          getSettingResponse.error = response.data.errors
        }
        return response
      })
      .catch((_: any) => {
        Sentry.captureException(_);
        getSettingResponse.error = 'Server error'
      })

    return getSettingResponse
  }
}
